import EmailSignature from './EmailSignature'

export default EmailSignature